import { gsap } from 'gsap';
import { GSDevTools } from 'gsap/GSDevTools';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import TextPlugin from 'gsap/TextPlugin';
import EasePack from 'gsap/EasePack';
import MorphSVGPlugin from 'gsap/MorphSVGPlugin';

gsap.registerPlugin(GSDevTools, ScrollTrigger, SplitText, TextPlugin, EasePack, MorphSVGPlugin);

// GSDevTools.create();

/**
 * objects parallax animation on scroll
 */

let timeline_1 = gsap.timeline({
  scrollTrigger: {trigger: '#image-1', start: 'top top', end: 'bottom top', scrub: true}
});

gsap.utils.toArray('.image-1').forEach(layer => {
  let depth = layer.dataset.depth;
  let movement = -(layer.offsetHeight * depth);
  timeline_1.to(layer, {y: movement, ease: 'none'}, 0);
});

/**
 * objects zooming in and out animation on idle
 */

gsap.set('#image-1b', {scaleX: 1.10, scaleY: 1.10});
let timeline_2 = gsap.timeline({repeat: -1, yoyo: true, ease: 'slow'});
timeline_2.to('#image-1a', {duration: 10, scaleX: 1.10, scaleY: 1.10}, 0);
timeline_2.to('#image-1b', {duration: 10, scaleX: 1.00, scaleY: 1.00}, '<');

gsap.set('#image-2b', {scaleX: 1.10, scaleY: 1.10});
timeline_2.to('#image-2a', {duration: 10, scaleX: 1.10, scaleY: 1.10}, 0);
timeline_2.to('#image-2b', {duration: 10, scaleX: 1.00, scaleY: 1.00}, '<');

/**
 * windy text animation on idle
 */

gsap.registerEffect({
  name: 'windy',
  extendTimeline: true,
  defaults: {
    duration: 1, rotationY: 360, ease: 'back(2)', repeat: -1, repeatDelay: gsap.utils.random(10, 20),
    stagger: {amount: 1, ease: 'power2.in'}
  },
  effect: (targets, config) => {
    gsap.set(targets, {autoAlpha: 1});
    let split = new SplitText(targets, {type: 'chars'});
    gsap.set(split.chars, {transformPerspective: 200});
    let timeline = gsap.timeline();
    timeline.to(split.chars, config);
  }
});

gsap.set('#title-wrapper', {autoAlpha: 1});
let timeline_3 = gsap.timeline();
timeline_3.windy('#title-1');
timeline_3.windy('#title-2');

/**
 * birds flying animation on idle
 */

let birds = gsap.utils.toArray('.birds');
let airfield = document.querySelector('#airfield');
let airfieldWidth = airfield.offsetWidth;
let airfieldHeight = airfield.offsetHeight;

gsap.set(birds, {
  xPercent: -50,
  yPercent: -50
});

// x/y values for how far away from the center they can move
let dx = airfieldWidth * 0.4;
let dy = airfieldHeight * 0.5;

function tweenProperty (target, prop, min, max) {
  gsap.to(target, {
    [prop]: gsap.utils.random(min, max),
    duration: 'random(3, 6)',
    ease: 'none',
    onComplete: tweenProperty,
    onCompleteParams: [target, prop, min, max],
  });
}

// animate our properties individually
tweenProperty(birds[0], 'scale', 0.2, 0.8);
tweenProperty(birds[0], 'x', -dx, dx);
tweenProperty(birds[0], 'y', -dy, dy);

tweenProperty(birds[1], 'scale', 0.5, 1.2);
tweenProperty(birds[1], 'x', -dx, dx);
tweenProperty(birds[1], 'y', -dy, dy);

tweenProperty(birds[2], 'scale', 0.4, 0.9);
tweenProperty(birds[2], 'x', -dx, dx);
tweenProperty(birds[2], 'y', -dy, dy);

// animation of the wings
let birdsFly = document.querySelectorAll('.birdsFly');

gsap.set(birdsFly[0], {
  fill: gsap.utils.random(['#FFFFFF', '#C2D848', '#32B1C2']),
});

gsap.set(birdsFly[1], {
  fill: gsap.utils.random(['#FFFFFF', '#C2D848', '#32B1C2']),
});

gsap.set(birdsFly[2], {
  fill: gsap.utils.random(['#FFFFFF', '#C2D848', '#32B1C2']),
});

gsap.to(birdsFly, {
  morphSVG: gsap.utils.wrap(['#bird1fly02', '#bird2fly02', '#bird3fly02']),
  duration: 'random(0.1, 0.4)', ease: 'power.inOut', stagger: 0.3, repeat: -1, yoyo: true, repeatRefresh: true,
  //repeatDelay: 0.07,
});

import SimpleLightbox from 'simple-lightbox';

let swiper_lightbox = new SimpleLightbox({
  elements: document.querySelectorAll('.swiper-lightbox a'),
});

import Vue from 'vue';
import VCalendar from 'v-calendar';
import PackageCalendar from './components/PackageCalendar';

Vue.use(VCalendar);

new Vue({
  el: '#package-calendar',
  render: h => h(PackageCalendar),
});

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import PackageBookingForm from './components/PackageBookingForm';

Vue.config.devtools = true;
Vue.config.silent = false;
Vue.use(VueSweetalert2);

let vue_recaptcha_options = {
  siteKey: window.package_post_script_data.google_recaptcha_site_key,
  loaderOptions: {
    autoHideBadge: true,
    explicitRenderParameters: {
      // badge: 'bottomleft',
      // size: 'invisible',
    }
  }
};

Vue.use(VueReCaptcha, vue_recaptcha_options);

new Vue({
  el: '#package-booking',
  render: h => h(PackageBookingForm),
});
